import React from "react";
import { Alert } from "@material-ui/lab";
import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../styles/styledTable";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import TelegramDrainWalletsItem from "./TelegramDrainWalletsItem";

const TelegramDrainWalletsList = ({ wallets, onActivated, onDelete, setNotification, t }) => {
  if (wallets === null) return <PageSpinner position="center" pt="20" pb="20" />;
  if (wallets.length === 0) return <Alert severity="warning">{t("drainWallets.table.emptyData")}</Alert>;

  return (
    <StyledScrollTable>
      <StyledTable width="1050" size="14">
        <StyledTableHead scroll="auto" col="8">
          <div>{t("drainWallets.table.project")}</div>
          <div>{t("drainWallets.table.type")}</div>
          <div>{t("drainWallets.table.network")}</div>
          <div>{t("drainWallets.table.label")}</div>
          <div>{t("drainWallets.table.address")}</div>
          <div>{t("drainWallets.table.status")}</div>
          <div>{t("drainWallets.table.createdAt")}</div>
          <div>{t("drainWallets.table.actions")}</div>
        </StyledTableHead>
        <StyledTableBody>
          {wallets.map(wallet => (
            <TelegramDrainWalletsItem key={wallet.id} wallet={wallet} onActivated={onActivated} onDelete={onDelete} setNotification={setNotification} t={t} />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default TelegramDrainWalletsList;